// // import React, { useContext } from "react";
// // import { useLocation } from "react-router-dom";
// // import { DataContext } from "../Screenss/DataContext";
// // import Footer from "../Screenss/Footer";
// // const ShowGallery = () => {
// //   const { data } = useContext(DataContext);
// //   const location = useLocation();

// //   // ✅ parameter receive
// //   const category = location.state?.category || "hero";

// //   // ✅ filter data
// //   const galleryItems = data.filter(
// //     (item) => item.category === category
// //   );

// //   return (
// //     <section style={styles.section}>
      
// //       <h2 style={styles.title}>Full Gallery</h2>

// //       <div className="galleryGrid">
// //         {galleryItems.map((item, i) => (
// //           <div
// //             className={`card ${item.big ? "bigCard" : ""}`}
// //             key={item.id || i}
// //           >
// //             {/* IMAGE / VIDEO */}
// //             {item.type === "video" ? (
// //               <video
// //                 src={item.full_url}
// //                 controls
// //                 className="video"
// //                 poster={item.thumbnail || ""}
// //               />
// //             ) : (
// //               <img src={item.full_url} alt={item.title || "Gallery"} />
// //             )}

// //             <div className="shutterOverlay">
// //               <div className="shutterContent">
// //                 <h3>{item.title || "Gallery Item"}</h3>
// //                 <p>{item.type === "video" ? "Watch Now 🎥" : "View Image"}</p>
// //               </div>
// //             </div>
// //           </div>
// //         ))}
// //       </div>

// //       <style jsx>{`${styles.galleryCSS}`}</style>
// // <Footer/>
// //     </section>
// //   );
// // };

// // const styles = {
// //   section: {
// //     padding: "60px 20px",
// //     background: "#fff",
// //     textAlign: "center",
// //   },

// //   title: {
// //     fontSize: "34px",
// //     marginBottom: "40px",
// //     fontWeight: "700",
// //     color: "#222",
// //     fontFamily: "sans-serif",
// //   },

// //   galleryCSS: `
// //     .galleryGrid {
// //       display: grid;
// //       grid-template-columns: repeat(4, 1fr); /* 🔥 more dense */
// //       grid-auto-rows: 220px;
// //       gap: 20px;
// //       max-width: 1300px;
// //       margin: auto;
// //     }

// //     .card {
// //       position: relative;
// //       overflow: hidden;
// //       border-radius: 20px;
// //       cursor: pointer;
// //       background: #000;
// //       box-shadow: 0 10px 30px rgba(0,0,0,0.1);
// //       transition: all 0.4s ease;
// //     }

// //     .bigCard {
// //       grid-column: span 2;
// //       grid-row: span 2;
// //     }

// //     .card img, .video {
// //       width: 100%;
// //       height: 100%;
// //       object-fit: cover;
// //       transition: transform 0.5s ease;
// //     }

// //     .shutterOverlay {
// //       position: absolute;
// //       inset: 0;
// //       background: linear-gradient(135deg, rgba(0,111,47,0.95), rgba(40,167,69,0.9));
// //       opacity: 0;
// //       transform: scale(0.8);
// //       transition: 0.4s;
// //       display: flex;
// //       align-items: center;
// //       justify-content: center;
// //     }

// //     .shutterContent {
// //       text-align: center;
// //       color: #fff;
// //       opacity: 0;
// //       transition: 0.3s 0.2s;
// //     }

// //     .shutterContent h3 {
// //       font-size: 20px;
// //       margin-bottom: 5px;
// //     }

// //     .card:hover img,
// //     .card:hover .video {
// //       transform: scale(1.05);
// //     }

// //     .card:hover .shutterOverlay {
// //       opacity: 1;
// //       transform: scale(1);
// //     }

// //     .card:hover .shutterContent {
// //       opacity: 1;
// //     }

// //     /* 📱 RESPONSIVE */

// //     @media(max-width: 1100px){
// //       .galleryGrid {
// //         grid-template-columns: repeat(3, 1fr);
// //       }
// //     }

// //     @media(max-width: 800px){
// //       .galleryGrid {
// //         grid-template-columns: repeat(2, 1fr);
// //       }
// //       .bigCard {
// //         grid-column: span 2;
// //         grid-row: span 1;
// //       }
// //     }

// //     @media(max-width: 500px){
// //       .galleryGrid {
// //         grid-template-columns: 1fr;
// //       }
// //       .bigCard {
// //         grid-column: span 1;
// //         grid-row: span 1;
// //       }
// //     }
// //   `,
// // };

// // export default ShowGallery;

// import React, { useContext, useState } from "react";
// import { useLocation } from "react-router-dom";
// import { DataContext } from "../Screenss/DataContext";
// import Footer from "../Screenss/Footer";

// const ShowGallery = () => {
//   const { data } = useContext(DataContext);
//   const location = useLocation();

//   const category = location.state?.category || "hero";

//   const galleryItems = data.filter(
//     (item) => item.category === category
//   );

//   const [activeIndex, setActiveIndex] = useState(null);

//   return (
//     <>
//       {/* 🔥 TOP BANNER */}
//       <div style={styles.hero}>
//         <img
//           src="https://images.unsplash.com/photo-1523050853064-dbad350090ad"
//           alt="Gallery Banner"
//           style={styles.heroImg}
//         />
//         <div style={styles.overlay}></div>

//         <div style={styles.heroContent}>
//           <h1>Our Gallery</h1>
//           <p>Explore Moments & Memories</p>
//         </div>
//       </div>

//       {/* 🔥 GALLERY */}
//       <section style={styles.section}>
//         <h2 style={styles.title}>Full Gallery</h2>

//         <div className="galleryGrid">
//           {galleryItems.map((item, i) => (
//             <div
//               className={`card ${item.big ? "bigCard" : ""}`}
//               key={item.id || i}
//               onClick={() => setActiveIndex(i)}
//             >
//               {item.type === "video" ? (
//                 <video
//                   src={item.full_url}
//                   className="video"
//                   poster={item.thumbnail || ""}
//                 />
//               ) : (
//                 <img src={item.full_url} alt={item.title || "Gallery"} />
//               )}

//               <div className="shutterOverlay">
//                 <div className="shutterContent">
//                   <h3>{item.title || "Gallery Item"}</h3>
//                   <p>
//                     {item.type === "video"
//                       ? "Watch Now 🎥"
//                       : "View Image"}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* 🔥 LIGHTBOX */}
//         {activeIndex !== null && (
//           <div style={styles.lightbox}>
            
//             {/* CLOSE */}
//             <span
//               style={styles.close}
//               onClick={() => setActiveIndex(null)}
//             >
//               ✕
//             </span>

//             {/* PREV */}
//             <span
//               style={styles.prev}
//               onClick={() =>
//                 setActiveIndex(
//                   activeIndex === 0
//                     ? galleryItems.length - 1
//                     : activeIndex - 1
//                 )
//               }
//             >
//               ‹
//             </span>

//             {/* NEXT */}
//             <span
//               style={styles.next}
//               onClick={() =>
//                 setActiveIndex(
//                   activeIndex === galleryItems.length - 1
//                     ? 0
//                     : activeIndex + 1
//                 )
//               }
//             >
//               ›
//             </span>

//             {/* MEDIA */}
//             {galleryItems[activeIndex].type === "video" ? (
//               <video
//                 src={galleryItems[activeIndex].full_url}
//                 controls
//                 autoPlay
//                 style={styles.lightMedia}
//               />
//             ) : (
//               <img
//                 src={galleryItems[activeIndex].full_url}
//                 style={styles.lightMedia}
//               />
//             )}
//           </div>
//         )}

//         <style jsx>{`${styles.galleryCSS}`}</style>
//       </section>

//       <Footer />
//     </>
//   );
// };

// const styles = {
//   /* 🔥 BANNER */
//   hero: {
//     position: "relative",
//     height: "320px",
//     width: "100%",
//     overflow: "hidden",
//   },

//   heroImg: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },

//   overlay: {
//     position: "absolute",
//     inset: 0,
//     background:
//       "linear-gradient(rgba(0,111,47,0.7), rgba(0,0,0,0.7))",
//   },

//   heroContent: {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     color: "#fff",
//     textAlign: "center",
//   },

//   /* 🔥 MAIN */
//   section: {
//     padding: "60px 20px",
//     background: "#fff",
//     textAlign: "center",
//   },

//   title: {
//     fontSize: "34px",
//     marginBottom: "40px",
//     fontWeight: "700",
//     color: "#222",
//     fontFamily: "sans-serif",
//   },

//   /* 🔥 LIGHTBOX */
//   lightbox: {
//     position: "fixed",
//     inset: 0,
//     background: "rgba(0,0,0,0.9)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 9999,
//   },

//   lightMedia: {
//     maxWidth: "90%",
//     maxHeight: "85%",
//     borderRadius: "10px",
//   },

//   close: {
//     position: "absolute",
//     top: "20px",
//     right: "30px",
//     fontSize: "30px",
//     color: "#fff",
//     cursor: "pointer",
//   },

//   prev: {
//     position: "absolute",
//     left: "20px",
//     fontSize: "50px",
//     color: "#fff",
//     cursor: "pointer",
//   },

//   next: {
//     position: "absolute",
//     right: "20px",
//     fontSize: "50px",
//     color: "#fff",
//     cursor: "pointer",
//   },

//   /* 🔥 GRID CSS */
//   galleryCSS: `
//     .galleryGrid {
//       display: grid;
//       grid-template-columns: repeat(4, 1fr);
//       grid-auto-rows: 220px;
//       gap: 20px;
//       max-width: 1300px;
//       margin: auto;
//     }

//     .card {
//       position: relative;
//       overflow: hidden;
//       border-radius: 20px;
//       cursor: pointer;
//       background: #000;
//       transition: 0.4s;
//     }

//     .bigCard {
//       grid-column: span 2;
//       grid-row: span 2;
//     }

//     .card img, .video {
//       width: 100%;
//       height: 100%;
//       object-fit: cover;
//     }

//     .shutterOverlay {
//       position: absolute;
//       inset: 0;
//       background: rgba(0,0,0,0.5);
//       opacity: 0;
//       transition: 0.3s;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//     }

//     .shutterContent {
//       color: #fff;
//       opacity: 0;
//       transition: 0.3s;
//     }

//     .card:hover .shutterOverlay {
//       opacity: 1;
//     }

//     .card:hover .shutterContent {
//       opacity: 1;
//     }

//     @media(max-width: 1100px){
//       .galleryGrid { grid-template-columns: repeat(3, 1fr); }
//     }

//     @media(max-width: 800px){
//       .galleryGrid { grid-template-columns: repeat(2, 1fr); }
//       .bigCard { grid-column: span 2; grid-row: span 1; }
//     }

//     @media(max-width: 500px){
//       .galleryGrid { grid-template-columns: 1fr; }
//       .bigCard { grid-column: span 1; grid-row: span 1; }
//     }
//   `,
// };

// export default ShowGallery;

// import React, { useContext, useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import { DataContext } from "../Screenss/DataContext";
// import Footer from "../Screenss/Footer";

// const ShowGallery = () => {
//   const { data } = useContext(DataContext);
//   const location = useLocation();

//   // Categories List matching your options
//   const categories = [
//     // { id: "hero", label: "Hero Section", icon: "🏠" },
//     { id: "gallery", label: "General Gallery", icon: "🖼️" },
//     { id: "sports", label: "Sports", icon: "🏆" },
//     // { id: "events", label: "Events", icon: "🎉" },
//     { id: "ourschool", label: "Our School", icon: "🏫" },
//     { id: "schoolstaff", label: "School Staff", icon: "👨‍🏫" },
//     { id: "schooltransport", label: "Transport", icon: "🚌" },
//     // { id: "abouthome", label: "About Home", icon: "ℹ️" },
//     // { id: "principaleimg", label: "Principal", icon: "🎓" },
//     // { id: "directoreimg", label: "Director", icon: "💼" },
//     { id: "Activities", label: "Activities", icon: "🎨" },
//   ];

//   // State for active category
//   const [selectedCategory, setSelectedCategory] = useState(
//     location.state?.category || "gallery"
//   );
//   const [activeIndex, setActiveIndex] = useState(null);

//   // Filter items based on selection
//   const galleryItems = data.filter((item) => item.category === selectedCategory);

//   // Get one preview image for the banner based on category
//   const bannerImg = galleryItems.length > 0 
//     ? galleryItems[0].full_url 
//     : "https://images.unsplash.com/photo-1523050853064-dbad350090ad";

//   return (
//     <>
//       {/* 🔥 TOP DYNAMIC BANNER */}
//       <div style={styles.hero}>
//         <img src={bannerImg} alt="Gallery Banner" style={styles.heroImg} />
//         <div style={styles.overlay}></div>
//         <div style={styles.heroContent}>
//           <h1 style={{fontSize: '3rem', margin: 0}}>{selectedCategory.toUpperCase()}</h1>
//           <p>Explore Moments & Memories of our School</p>
//         </div>
//       </div>

//       {/* 🧭 CATEGORY SELECTOR BAR */}
//       <div style={styles.categoryBar}>
//         <div className="scroll-container" style={styles.scrollContainer}>
//           {categories.map((cat) => (
//             <div
//               key={cat.id}
//               onClick={() => setSelectedCategory(cat.id)}
//               style={{
//                 ...styles.categoryTab,
//                 background: selectedCategory === cat.id ? "rgb(0,111,47)" : "#fff",
//                 color: selectedCategory === cat.id ? "#fff" : "#333",
//                 boxShadow: selectedCategory === cat.id ? "0 5px 15px rgba(0,111,47,0.3)" : "none",
//               }}
//             >
//               <span style={{ fontSize: "20px" }}>{cat.icon}</span>
//               <span style={{ fontWeight: "600" }}>{cat.label}</span>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* 🖼️ GALLERY GRID */}
//       <section style={styles.section}>
//         {galleryItems.length > 0 ? (
//           <div className="galleryGrid">
//             {galleryItems.map((item, i) => (
//               <div
//                 className={`card ${item.big ? "bigCard" : ""}`}
//                 key={item.id || i}
//                 onClick={() => setActiveIndex(i)}
//               >
//                 {item.type === "video" ? (
//                   <video src={item.full_url} className="video" poster={item.thumbnail || ""} />
//                 ) : (
//                   <img src={item.full_url} alt={item.title} />
//                 )}
//                 <div className="shutterOverlay">
//                   <div className="shutterContent">
//                     <h3>{item.title || "View"}</h3>
//                     <p>{item.type === "video" ? "Play Video 🎥" : "View Photo"}</p>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <div style={{padding: '50px', fontSize: '1.2rem', color: '#666'}}>
//             No items found in this category.
//           </div>
//         )}

//         {/* 🔦 LIGHTBOX (Same as before) */}
//         {activeIndex !== null && (
//           <div style={styles.lightbox}>
//             <span style={styles.close} onClick={() => setActiveIndex(null)}>✕</span>
//             <span style={styles.prev} onClick={() => setActiveIndex(activeIndex === 0 ? galleryItems.length - 1 : activeIndex - 1)}>‹</span>
//             <span style={styles.next} onClick={() => setActiveIndex(activeIndex === galleryItems.length - 1 ? 0 : activeIndex + 1)}>›</span>
//             {galleryItems[activeIndex].type === "video" ? (
//               <video src={galleryItems[activeIndex].full_url} controls autoPlay style={styles.lightMedia} />
//             ) : (
//               <img src={galleryItems[activeIndex].full_url} style={styles.lightMedia} />
//             )}
//           </div>
//         )}

//         <style jsx>{`${styles.galleryCSS}`}</style>
//       </section>

//       <Footer />
//     </>
//   );
// };

// const styles = {
//       hero: {
//     width: "100%",
//     marginTop: "120px",
//   },
//   heroImageWrap: {
//     position: "relative",
//     width: "100%",
//     height: "560px",
//     overflow: "hidden",
//     marginTop:140
//   },
//    heroImg: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//     display: "block",
//   },
//   hero: { position: "relative", height: "560px", width: "100%", overflow: "hidden",marginTop:140 },
//   heroImg: { width: "100%", height: "100%", objectFit: "cover", transition: '1s ease' },
// //   overlay: { position: "center", inset: 0, background: "linear-gradient(rgba(0,111,47,0.4), rgba(0,0,0,0.8))" },
// //   heroContent: { position: "absolute", bottom: "60px", left: "50%", transform: "translateX(-50%)", color: "#fff", textAlign: "center", width: '100%' },

//   categoryBar: {
//     background: "whiet",
//     padding: "20px 0",
//     position: "sticky",
//     top: "0",
//     zIndex: 100,
//     boxShadow: "0 4px 10px rgba(0,0,0,0.05)"
//   },
//   scrollContainer: {
//     display: "flex",
//     gap: "15px",
//     overflowX: "auto",
//     padding: "0 20px",
//     maxWidth: "1300px",
//     margin: "auto",
//     scrollbarWidth: "none", // Hide scrollbar for Firefox
//   },
//   categoryTab: {
//     display: "flex",
//     alignItems: "center",
//     gap: "10px",
//     padding: "12px 25px",
//     borderRadius: "50px",
//     cursor: "pointer",
//     whiteSpace: "nowrap",
//     transition: "0.3s ease",
//     border: "1px solid #ddd"
//   },

//   section: { padding: "60px 20px", background: "#fff", textAlign: "center" },
//   lightbox: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.95)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 },
//   lightMedia: { maxWidth: "90%", maxHeight: "85%", borderRadius: "10px", boxShadow: '0 0 50px rgba(0,0,0,0.5)' },
//   close: { position: "absolute", top: "20px", right: "30px", fontSize: "35px", color: "#fff", cursor: "pointer" },
//   prev: { position: "absolute", left: "20px", fontSize: "60px", color: "#fff", cursor: "pointer" },
//   next: { position: "absolute", right: "20px", fontSize: "60px", color: "#fff", cursor: "pointer" },

//   galleryCSS: `
//     .scroll-container::-webkit-scrollbar { display: none; } /* Hide scrollbar Chrome */
//     .galleryGrid {
//       display: grid;
//       grid-template-columns: repeat(4, 1fr);
//       grid-auto-rows: 240px;
//       gap: 20px;
//       max-width: 1300px;
//       margin: auto;
//     }
//     .card {
//       position: relative;
//       overflow: hidden;
//       border-radius: 15px;
//       cursor: pointer;
//       background: #eee;
//       transition: 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
//     }
//     .card:hover { transform: scale(1.02); z-index: 2; }
//     .bigCard { grid-column: span 2; grid-row: span 2; }
//     .card img, .video { width: 100%; height: 100%; object-fit: cover; }
//     .shutterOverlay {
//       position: absolute;
//       inset: 0;
//       background: rgba(0,111,47,0.8);
//       opacity: 0;
//       transition: 0.3s;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//     }
//     .card:hover .shutterOverlay { opacity: 1; }
//     .shutterContent { color: #fff; text-align: center; }
    
//     @media(max-width: 1100px){ .galleryGrid { grid-template-columns: repeat(3, 1fr); } }
//     @media(max-width: 800px){ .galleryGrid { grid-template-columns: repeat(2, 1fr); } }
//     @media(max-width: 500px){ .galleryGrid { grid-template-columns: 1fr; } .hero { height: 250px !important; } }
//   `,
// };

// export default ShowGallery;

// import React, { useContext, useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import { DataContext } from "../Screenss/DataContext";
 

// const ShowGallery = () => {
//   const { data } = useContext(DataContext);
//   const location = useLocation();

//   const categories = [
//     { id: "gallery", label: "General Gallery", icon: "🖼️" },
//     { id: "sports", label: "Sports", icon: "🏆" },
//     { id: "ourschool", label: "Our School", icon: "🏫" },
//     { id: "schoolstaff", label: "School Staff", icon: "👨‍🏫" },
//     { id: "schooltransport", label: "Transport", icon: "🚌" },
//     { id: "Activities", label: "Activities", icon: "🎨" },
//   ];

//   const [selectedCategory, setSelectedCategory] = useState(
//     location.state?.category || "gallery"
//   );

//   const [activeIndex, setActiveIndex] = useState(null);
//   const [current, setCurrent] = useState(0);

//   const galleryItems = data.filter(
//     (item) => item.category === selectedCategory
//   );

//   // 🔥 AUTO SLIDER
//   useEffect(() => {
//     if (galleryItems.length === 0) return;

//     const interval = setInterval(() => {
//       setCurrent((prev) =>
//         prev === galleryItems.length - 1 ? 0 : prev + 1
//       );
//     }, 3000);

//     return () => clearInterval(interval);
//   }, [galleryItems]);

//   return (
//     <>
//       {/* 🔥 TOP SLIDER */}
//       <div style={styles.hero}>
//         {galleryItems.length > 0 ? (
//           <img
//             src={galleryItems[current].full_url}
//             alt="banner"
//             style={styles.heroImg}
//           />
//         ) : (
//           <img
//             src="https://images.unsplash.com/photo-1523050853064-dbad350090ad"
//             style={styles.heroImg}
//           />
//         )}

//         <div style={styles.overlay}></div>

//         <div style={styles.heroContent}>
//           <h1>{selectedCategory.toUpperCase()}</h1>
//           <p>Explore Moments & Memories</p>
//         </div>

//         {/* 🔘 DOTS */}
//         <div style={styles.dots}>
//           {galleryItems.map((_, i) => (
//             <span
//               key={i}
//               onClick={() => setCurrent(i)}
//               style={{
//                 ...styles.dot,
//                 background:
//                   current === i ? "rgb(0,111,47)" : "#fff",
//               }}
//             />
//           ))}
//         </div>
//       </div>

//       {/* 🔥 CATEGORY BAR */}
//       <div style={styles.categoryBar}>
//         <div className="scroll-container" style={styles.scrollContainer}>
//           {categories.map((cat) => (
//             <div
//               key={cat.id}
//               onClick={() => {
//                 setSelectedCategory(cat.id);
//                 setCurrent(0);
//               }}
//               style={{
//                 ...styles.categoryTab,
//                 background:
//                   selectedCategory === cat.id
//                     ? "rgb(0,111,47)"
//                     : "#fff",
//                 color:
//                   selectedCategory === cat.id ? "#fff" : "#333",
//               }}
//             >
//               <span>{cat.icon}</span>
//               <span>{cat.label}</span>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* 🔥 GALLERY */}
//       <section style={styles.section}>
//         {galleryItems.length > 0 ? (
//           <div className="galleryGrid">
//             {galleryItems.map((item, i) => (
//               <div
//                 className="card"
//                 key={i}
//                 onClick={() => setActiveIndex(i)}
//               >
//                 {item.type === "video" ? (
//                   <video src={item.full_url} className="video" />
//                 ) : (
//                   <img src={item.full_url} alt="gallery" />
//                 )}

//                 <div className="overlayCard">
//                   <p>View</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <p>No Data Found</p>
//         )}

//         {/* 🔥 LIGHTBOX */}

//           {activeIndex !== null && (
//           <div style={styles.lightbox}>
//             <span style={styles.close} onClick={() => setActiveIndex(null)}>✕</span>
//             <span style={styles.prev} onClick={() => setActiveIndex(activeIndex === 0 ? galleryItems.length - 1 : activeIndex - 1)}>‹</span>
//             <span style={styles.next} onClick={() => setActiveIndex(activeIndex === galleryItems.length - 1 ? 0 : activeIndex + 1)}>›</span>
//             {galleryItems[activeIndex].type === "video" ? (
//               <video src={galleryItems[activeIndex].full_url} controls autoPlay style={styles.lightMedia} />
//             ) : (
//               <img src={galleryItems[activeIndex].full_url} style={styles.lightMedia} />
//             )}
//           </div>
//         )}
//         {/* {activeIndex !== null && (
//           <div style={styles.lightbox}>
//             <span
//               style={styles.close}
//               onClick={() => setActiveIndex(null)}
//             >
//               ✕
//             </span>

//             <span
//               style={styles.prev}
//               onClick={() =>
//                 setActiveIndex(
//                   activeIndex === 0
//                     ? galleryItems.length - 1
//                     : activeIndex - 1
//                 )
//               }
//             >
//               ‹
//             </span>

//             <span
//               style={styles.next}
//               onClick={() =>
//                 setActiveIndex(
//                   activeIndex === galleryItems.length - 1
//                     ? 0
//                     : activeIndex + 1
//                 )
//               }
//             >
//               ›
//             </span>

//             <img
//               src={galleryItems[activeIndex].full_url}
//               style={styles.lightMedia}
//             />
//           </div>
//         )} */}

//         <style>{styles.galleryCSS}</style>
//       </section>
// <div>
  
// </div>
   
//     </>
//   );
// };

// export default ShowGallery;

// const styles = {
//   hero: {
//     position: "relative",
//     height: "550px",
//     overflow: "hidden",
//     marginTop: 120,
//   },

//   heroImg: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },

//   overlay: {
//     position: "absolute",
//     inset: 0,
//     background:
//       "linear-gradient(rgba(0,111,47,0.5), rgba(0,0,0,0.7))",
//   },

//   heroContent: {
//     position: "absolute",
//     bottom: "40px",
//     left: "50%",
//     transform: "translateX(-50%)",
//     color: "#fff",
//     textAlign: "center",
//   },

//   dots: {
//     position: "absolute",
//     bottom: "15px",
//     left: "50%",
//     transform: "translateX(-50%)",
//     display: "flex",
//     gap: "8px",
//   },

//   dot: {
//     width: "10px",
//     height: "10px",
//     borderRadius: "50%",
//     cursor: "pointer",
//   },

//   categoryBar: {
//     padding: "15px 0",
//     background: "#fff",
//     position: "sticky",
//     top: 0,
//     zIndex: 10,
//   },

//   scrollContainer: {
//     display: "flex",
//     gap: "10px",
//     overflowX: "auto",
//     padding: "0 20px",
//   },

//   categoryTab: {
//     padding: "10px 20px",
//     borderRadius: "50px",
//     border: "1px solid #ddd",
//     cursor: "pointer",
//     display: "flex",
//     gap: "8px",
//   },

//   section: {
//     padding: "50px 20px",
//   },

//      lightbox: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.95)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 },
//   lightMedia: { maxWidth: "90%", maxHeight: "85%", borderRadius: "10px", boxShadow: '0 0 50px rgba(0,0,0,0.5)' },
//   close: { position: "absolute", top: "20px", right: "30px", fontSize: "35px", color: "#fff", cursor: "pointer" },
//   prev: { position: "absolute", left: "20px", fontSize: "60px", color: "#fff", cursor: "pointer" },
//   next: { position: "absolute", right: "20px", fontSize: "60px", color: "#fff", cursor: "pointer" },


//   galleryCSS: `
//     .galleryGrid {
//       display: grid;
//       grid-template-columns: repeat(4,1fr);
//       gap: 15px;
//     }

//     .card {
//       position: relative;
//       height: 220px;
//       overflow: hidden;
//       border-radius: 10px;
//       cursor: pointer;
//     }

//     .card img, .video {
//       width: 100%;
//       height: 100%;
//       object-fit: cover;
//     }

//     .overlayCard {
//       position: absolute;
//       inset: 0;
//       background: rgba(0,0,0,0.4);
//       display:flex;
//       justify-content:center;
//       align-items:center;
//       opacity:0;
//       transition:0.3s;
//       color:#fff;
//     }

//     .card:hover .overlayCard {
//       opacity:1;
//     }

//     @media(max-width:900px){
//       .galleryGrid { grid-template-columns: repeat(2,1fr); }
//     }

//     @media(max-width:500px){
//       .galleryGrid { grid-template-columns: 1fr; }
//     }
//   `,
// };
// import React, { useContext, useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import { DataContext } from "../Screenss/DataContext";

// const ShowGallery = () => {
//   const { data } = useContext(DataContext);
//   const location = useLocation();

//   const categories = [
//     { id: "gallery", label: "General Gallery", icon: "🖼️" },
//     { id: "sports", label: "Sports", icon: "🏆" },
//     { id: "ourschool", label: "Our School", icon: "🏫" },
//     { id: "schoolstaff", label: "School Staff", icon: "👨‍🏫" },
//     { id: "schooltransport", label: "Transport", icon: "🚌" },
//     { id: "Activities", label: "Activities", icon: "🎨" },
//   ];

//   const [selectedCategory, setSelectedCategory] = useState(
//     location.state?.category || "gallery"
//   );

//   const [activeIndex, setActiveIndex] = useState(null);
//   const [current, setCurrent] = useState(0);

//   const galleryItems = data.filter(
//     (item) => item.category === selectedCategory
//   );

//   // AUTO SLIDER Logic
//   useEffect(() => {
//     if (galleryItems.length === 0) return;
//     const interval = setInterval(() => {
//       setCurrent((prev) => (prev === galleryItems.length - 1 ? 0 : prev + 1));
//     }, 4000);
//     return () => clearInterval(interval);
//   }, [galleryItems]);

//   return (
//     <div style={styles.container}>
//       {/* 🔥 HERO SECTION (Responsive Height) */}
//       <div style={styles.hero}>
//         {galleryItems.length > 0 ? (
//           <img
//             src={galleryItems[current].full_url}
//             alt="banner"
//             style={styles.heroImg}
//           />
//         ) : (
//           <img
//             src="https://images.unsplash.com/photo-1523050853064-dbad350090ad"
//             alt="placeholder"
//             style={styles.heroImg}
//           />
//         )}

//         <div style={styles.overlay}></div>

//         <div style={styles.heroContent}>
//           <h1 className="heroTitle">{selectedCategory.toUpperCase()}</h1>
//           <p className="heroSub">Explore Moments & Memories</p>
//         </div>

//         <div style={styles.dots}>
//           {galleryItems.slice(0, 10).map((_, i) => ( // Limiting dots for mobile
//             <span
//               key={i}
//               onClick={() => setCurrent(i)}
//               style={{
//                 ...styles.dot,
//                 background: current === i ? "#fff" : "rgba(255,255,255,0.4)",
//                 width: current === i ? "25px" : "10px",
//               }}
//             />
//           ))}
//         </div>
//       </div>

//       {/* 🔥 STICKY CATEGORY BAR */}
//       <div style={styles.categoryBar}>
//         <div className="scroll-container" style={styles.scrollContainer}>
//           {categories.map((cat) => (
//             <div
//               key={cat.id}
//               onClick={() => {
//                 setSelectedCategory(cat.id);
//                 setCurrent(0);
//               }}
//               className="categoryTab"
//               style={{
//                 ...styles.categoryTab,
//                 background: selectedCategory === cat.id ? "rgb(0,111,47)" : "#f4f4f4",
//                 color: selectedCategory === cat.id ? "#fff" : "#333",
//               }}
//             >
//               <span>{cat.icon}</span>
//               <span style={{whiteSpace: 'nowrap'}}>{cat.label}</span>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* 🔥 GALLERY GRID */}
//       <section style={styles.section}>
//         {galleryItems.length > 0 ? (
//           <div className="galleryGrid">
//             {galleryItems.map((item, i) => (
//               <div
//                 className="card"
//                 key={i}
//                 onClick={() => setActiveIndex(i)}
//               >
//                 {item.type === "video" ? (
//                   <video src={item.full_url} className="video" />
//                 ) : (
//                   <img src={item.full_url} alt="gallery" loading="lazy" />
//                 )}
//                 <div className="overlayCard">
//                   <p>View Full</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <div style={styles.noData}>No Media Found in this category</div>
//         )}

//         {/* 🔥 LIGHTBOX (Optimized for Touch) */}
//         {activeIndex !== null && (
//           <div style={styles.lightbox}>
//             <span style={styles.close} onClick={() => setActiveIndex(null)}>✕</span>
//             <span style={styles.prev} onClick={() => setActiveIndex(activeIndex === 0 ? galleryItems.length - 1 : activeIndex - 1)}>‹</span>
//             <span style={styles.next} onClick={() => setActiveIndex(activeIndex === galleryItems.length - 1 ? 0 : activeIndex + 1)}>›</span>
            
//             <div style={styles.mediaContainer}>
//                 {galleryItems[activeIndex].type === "video" ? (
//                 <video src={galleryItems[activeIndex].full_url} controls autoPlay style={styles.lightMedia} />
//                 ) : (
//                 <img src={galleryItems[activeIndex].full_url} style={styles.lightMedia} alt="enlarged" />
//                 )}
//             </div>
//           </div>
//         )}

//         <style>{styles.galleryCSS}</style>
//       </section>
//     </div>
//   );
// };

// export default ShowGallery;

// const styles = {
//   container: {
//     fontFamily: "'Poppins', sans-serif",
//     background: "#fff",
//   },
//   hero: {
//     position: "relative",
//     height: "80vh", // Responsive height based on viewport
//     minHeight: "350px",
//     overflow: "hidden",
//     marginTop: "80px", // Adjust based on your Navbar
//   },
//   heroImg: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//     transition: "0.5s ease-in-out",
//   },
//   overlay: {
//     position: "absolute",
//     inset: 0,
//     background: "linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.8))",
//   },
//   heroContent: {
//     position: "absolute",
//     bottom: "20%",
//     width: "100%",
//     color: "#fff",
//     textAlign: "center",
//     zIndex: 2,
//     padding: "0 20px",
//   },
//   dots: {
//     position: "absolute",
//     bottom: "20px",
//     left: "50%",
//     transform: "translateX(-50%)",
//     display: "flex",
//     gap: "8px",
//     zIndex: 3,
//   },
//   dot: {
//     height: "10px",
//     borderRadius: "10px",
//     cursor: "pointer",
//     transition: "all 0.3s ease",
//   },
//   categoryBar: {
//     padding: "20px 0",
//     background: "#fff",
//     position: "sticky",
//     top: 0,
//     zIndex: 100,
//     boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
//   },
//   scrollContainer: {
//     display: "flex",
//     gap: "12px",
//     overflowX: "auto",
//     padding: "0 20px",
//     scrollbarWidth: "none", // For Firefox
//     msOverflowStyle: "none", // For IE
//   },
//   categoryTab: {
//     padding: "10px 24px",
//     borderRadius: "50px",
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     gap: "10px",
//     fontSize: "14px",
//     fontWeight: "500",
//     transition: "all 0.3s ease",
//     boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
//   },
//   section: {
//     padding: "40px 5%",
//     minHeight: "400px",
//   },
//   noData: {
//     textAlign: "center",
//     padding: "50px",
//     color: "#888",
//     fontSize: "18px",
//   },
//   lightbox: {
//     position: "fixed",
//     inset: 0,
//     background: "rgba(0,0,0,0.95)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 10000,
//   },
//   mediaContainer: {
//     position: "relative",
//     width: "90%",
//     height: "80%",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//   },
//   lightMedia: {
//     maxWidth: "100%",
//     maxHeight: "100%",
//     borderRadius: "8px",
//     objectFit: "contain",
//   },
//   close: { position: "absolute", top: "25px", right: "25px", fontSize: "30px", color: "#fff", cursor: "pointer", zIndex: 11 },
//   prev: { position: "absolute", left: "15px", fontSize: "50px", color: "#fff", cursor: "pointer", userSelect: "none" },
//   next: { position: "absolute", right: "15px", fontSize: "50px", color: "#fff", cursor: "pointer", userSelect: "none" },

//   galleryCSS: `
//     .scroll-container::-webkit-scrollbar { display: none; }
    
//     .heroTitle { font-size: 3rem; margin-bottom: 10px; font-weight: 800; letter-spacing: 2px; }
//     .heroSub { font-size: 1.2rem; opacity: 0.9; }

//     .galleryGrid {
//       display: grid;
//       grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
//       gap: 20px;
//     }

//     .card {
//       position: relative;
//       height: 250px;
//       overflow: hidden;
//       border-radius: 15px;
//       cursor: pointer;
//       box-shadow: 0 10px 20px rgba(0,0,0,0.08);
//       transition: transform 0.3s ease;
//     }

//     .card:hover { transform: translateY(-5px); }

//     .card img, .video {
//       width: 100%;
//       height: 100%;
//       object-fit: cover;
//       transition: 0.5s;
//     }

//     .card:hover img { transform: scale(1.1); }

//     .overlayCard {
//       position: absolute;
//       inset: 0;
//       background: rgba(0, 111, 47, 0.7);
//       display: flex;
//       justify-content: center;
//       align-items: center;
//       opacity: 0;
//       transition: 0.4s ease;
//       color: #fff;
//       font-weight: 600;
//     }

//     .card:hover .overlayCard { opacity: 1; }

//     /* Media Queries for Mobile */
//     @media (max-width: 768px) {
//       .heroTitle { font-size: 2rem; }
//       .heroSub { font-size: 1rem; }
//       .galleryGrid { grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 10px; }
//       .card { height: 180px; }
//       .prev, .next { display: none; } /* Hide arrows on mobile for better touch experience */
//     }
//   `,
// };
import React, { useContext, useState, useEffect, useMemo, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { DataContext } from "../Screenss/DataContext";

const ShowGallery = () => {
  const { data } = useContext(DataContext);
  const location = useLocation();

  const categories = [
    { id: "gallery", label: "General Gallery", icon: "🖼️" },
    { id: "sports", label: "Sports", icon: "🏆" },
    { id: "ourschool", label: "Our School", icon: "🏫" },
    { id: "schoolstaff", label: "School Staff", icon: "👨‍🏫" },
    { id: "schooltransport", label: "Transport", icon: "🚌" },
    { id: "Activities", label: "Activities", icon: "🎨" },
  ];

  const [selectedCategory, setSelectedCategory] = useState(
    location.state?.category || "gallery"
  );
  const [activeIndex, setActiveIndex] = useState(null);
  const [current, setCurrent] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  // 🔥 OPTIMIZATION 1: Pre-group data by category (ONE TIME ONLY)
  const groupedData = useMemo(() => {
    const groups = {};
    categories.forEach(cat => {
      groups[cat.id] = data.filter(item => item.category === cat.id);
    });
    return groups;
  }, [data]);

  // 🔥 Get current category items (INSTANT ACCESS)
  const galleryItems = groupedData[selectedCategory] || [];

  // 🔥 OPTIMIZATION 2: Memoized category handler
  const handleCategoryChange = useCallback((catId) => {
    setIsLoading(true);
    setSelectedCategory(catId);
    setCurrent(0);
    setActiveIndex(null);
    // Instant reset loading
    setTimeout(() => setIsLoading(false), 100);
  }, []);

  // 🔥 OPTIMIZATION 3: Reset slider when category changes
  useEffect(() => {
    setCurrent(0);
    setActiveIndex(null);
  }, [selectedCategory]);

  // 🔥 OPTIMIZATION 4: Optimized auto slider
  useEffect(() => {
    if (galleryItems.length === 0 || isLoading) return;
    const interval = setInterval(() => {
      setCurrent((prev) => (prev === galleryItems.length - 1 ? 0 : prev + 1));
    }, 4000);
    return () => clearInterval(interval);
  }, [galleryItems.length, isLoading]);

  return (
    <div style={styles.container}>
      {/* 🔥 HERO SECTION */}
      <div style={styles.hero}>
        {isLoading ? (
          <div style={styles.loadingHero}>Loading...</div>
        ) : galleryItems.length > 0 ? (
          <img
            src={galleryItems[current].full_url}
            alt="banner"
            style={styles.heroImg}
            loading="lazy"
          />
        ) : (
          <img
            src="https://images.unsplash.com/photo-1523050853064-dbad350090ad"
            alt="placeholder"
            style={styles.heroImg}
          />
        )}

        <div style={styles.overlay}></div>

        <div style={styles.heroContent}>
          <h1 className="heroTitle">{selectedCategory.toUpperCase()}</h1>
          <p className="heroSub">
            {isLoading ? "Loading..." : "Explore Moments & Memories"}
          </p>
        </div>

        {!isLoading && galleryItems.length > 0 && (
          <div style={styles.dots}>
            {galleryItems.slice(0, 10).map((_, i) => (
              <span
                key={i}
                onClick={() => setCurrent(i)}
                style={{
                  ...styles.dot,
                  background: current === i ? "#fff" : "rgba(255,255,255,0.4)",
                  width: current === i ? "25px" : "10px",
                }}
              />
            ))}
          </div>
        )}
      </div>

      {/* 🔥 STICKY CATEGORY BAR */}
      <div style={styles.categoryBar}>
        <div className="scroll-container" style={styles.scrollContainer}>
          {categories.map((cat) => (
            <div
              key={cat.id}
              onClick={() => handleCategoryChange(cat.id)}
              className="categoryTab"
              style={{
                ...styles.categoryTab,
                background: selectedCategory === cat.id ? "rgb(0,111,47)" : "#f4f4f4",
                color: selectedCategory === cat.id ? "#fff" : "#333",
              }}
            >
              <span>{cat.icon}</span>
              <span style={{ whiteSpace: 'nowrap' }}>{cat.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* 🔥 GALLERY GRID */}
      <section style={styles.section}>
        {isLoading ? (
          <div style={styles.loadingGrid}>Switching category...</div>
        ) : galleryItems.length > 0 ? (
          <div className="galleryGrid">
            {galleryItems.map((item, i) => (
              <div
                className="card"
                key={`${item.full_url}-${i}`} // 🔥 Better key
                onClick={() => setActiveIndex(i)}
              >
                {item.type === "video" ? (
                  <video src={item.full_url} className="video" preload="none" />
                ) : (
                  <img 
                    src={item.full_url} 
                    alt="gallery" 
                    loading="lazy"
                  />
                )}
                <div className="overlayCard">
                  <p>View Full</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div style={styles.noData}>No Media Found in this category</div>
        )}

        {/* 🔥 LIGHTBOX */}
        {activeIndex !== null && galleryItems.length > 0 && (
          <div style={styles.lightbox}>
            <span style={styles.close} onClick={() => setActiveIndex(null)}>✕</span>
            <span 
              style={styles.prev} 
              onClick={() => setActiveIndex(activeIndex === 0 ? galleryItems.length - 1 : activeIndex - 1)}
            >‹</span>
            <span 
              style={styles.next} 
              onClick={() => setActiveIndex(activeIndex === galleryItems.length - 1 ? 0 : activeIndex + 1)}
            >›</span>
            
            <div style={styles.mediaContainer}>
              {galleryItems[activeIndex].type === "video" ? (
                <video 
                  src={galleryItems[activeIndex].full_url} 
                  controls 
                  autoPlay 
                  style={styles.lightMedia} 
                />
              ) : (
                <img 
                  src={galleryItems[activeIndex].full_url} 
                  style={styles.lightMedia} 
                  alt="enlarged" 
                />
              )}
            </div>
          </div>
        )}

        <style>{styles.galleryCSS}</style>
      </section>
    </div>
  );
};

export default ShowGallery;
 const styles = {
  container: {
    fontFamily: "'Poppins', sans-serif",
    background: "#fff",
  },
  hero: {
    position: "relative",
    height: "80vh", // Responsive height based on viewport
    minHeight: "350px",
    overflow: "hidden",
    marginTop: "80px", // Adjust based on your Navbar
  },
  heroImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "0.5s ease-in-out",
  },
  overlay: {
    position: "absolute",
    inset: 0,
    background: "linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.8))",
  },
  heroContent: {
    position: "absolute",
    bottom: "20%",
    width: "100%",
    color: "#fff",
    textAlign: "center",
    zIndex: 2,
    padding: "0 20px",
  },
  dots: {
    position: "absolute",
    bottom: "20px",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    gap: "8px",
    zIndex: 3,
  },
  dot: {
    height: "10px",
    borderRadius: "10px",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  categoryBar: {
    padding: "20px 0",
    background: "#fff",
    position: "sticky",
    top: 0,
    zIndex: 100,
    boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
  },
  scrollContainer: {
    display: "flex",
    gap: "12px",
    overflowX: "auto",
    padding: "0 20px",
    scrollbarWidth: "none", // For Firefox
    msOverflowStyle: "none", // For IE
  },
  categoryTab: {
    padding: "10px 24px",
    borderRadius: "50px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "14px",
    fontWeight: "500",
    transition: "all 0.3s ease",
    boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
  },
  section: {
    padding: "40px 5%",
    minHeight: "400px",
  },
  noData: {
    textAlign: "center",
    padding: "50px",
    color: "#888",
    fontSize: "18px",
  },
  lightbox: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.95)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10000,
  },
  mediaContainer: {
    position: "relative",
    width: "90%",
    height: "80%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  lightMedia: {
    maxWidth: "100%",
    maxHeight: "100%",
    borderRadius: "8px",
    objectFit: "contain",
  },
  close: { position: "absolute", top: "25px", right: "25px", fontSize: "30px", color: "#fff", cursor: "pointer", zIndex: 11 },
  prev: { position: "absolute", left: "15px", fontSize: "50px", color: "#fff", cursor: "pointer", userSelect: "none" },
  next: { position: "absolute", right: "15px", fontSize: "50px", color: "#fff", cursor: "pointer", userSelect: "none" },

  galleryCSS: `
    .scroll-container::-webkit-scrollbar { display: none; }
    
    .heroTitle { font-size: 3rem; margin-bottom: 10px; font-weight: 800; letter-spacing: 2px; }
    .heroSub { font-size: 1.2rem; opacity: 0.9; }

    .galleryGrid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      gap: 20px;
    }

    .card {
      position: relative;
      height: 250px;
      overflow: hidden;
      border-radius: 15px;
      cursor: pointer;
      box-shadow: 0 10px 20px rgba(0,0,0,0.08);
      transition: transform 0.3s ease;
    }

    .card:hover { transform: translateY(-5px); }

    .card img, .video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: 0.5s;
    }

    .card:hover img { transform: scale(1.1); }

    .overlayCard {
      position: absolute;
      inset: 0;
      background: rgba(0, 111, 47, 0.7);
      display: flex;
      justify-content: center;
      align-items: center;
      opacity: 0;
      transition: 0.4s ease;
      color: #fff;
      font-weight: 600;
    }

    .card:hover .overlayCard { opacity: 1; }

    /* Media Queries for Mobile */
    @media (max-width: 768px) {
      .heroTitle { font-size: 2rem; }
      .heroSub { font-size: 1rem; }
      .galleryGrid { grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 10px; }
      .card { height: 180px; }
      .prev, .next { display: none; } /* Hide arrows on mobile for better touch experience */
    }
  `,
};
// import React, { useContext, useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import { DataContext } from "../Screenss/DataContext";
// import Footer from "../Screenss/Footer";

// const ShowGallery = () => {
//   const { data } = useContext(DataContext);
//   const location = useLocation();

//   const categories = [
//     { id: "gallery", label: "General Gallery", icon: "🖼️" },
//     { id: "sports", label: "Sports", icon: "🏆" },
//     { id: "ourschool", label: "Our School", icon: "🏫" },
//     { id: "schoolstaff", label: "School Staff", icon: "👨‍🏫" },
//     { id: "schooltransport", label: "Transport", icon: "🚌" },
//     { id: "Activities", label: "Activities", icon: "🎨" },
//   ];

//   const [selectedCategory, setSelectedCategory] = useState(
//     location.state?.category || "gallery"
//   );

//   const [activeIndex, setActiveIndex] = useState(null);
//   const [current, setCurrent] = useState(0);

//   const galleryItems = data.filter(
//     (item) => item.category === selectedCategory
//   );

//   useEffect(() => {
//     if (galleryItems.length === 0) return;

//     const interval = setInterval(() => {
//       setCurrent((prev) =>
//         prev === galleryItems.length - 1 ? 0 : prev + 1
//       );
//     }, 3000);

//     return () => clearInterval(interval);
//   }, [galleryItems]);

//   return (
//     <>
//       {/* HERO */}
//       <div style={styles.hero}>
//         <img
//           src={
//             galleryItems.length > 0
//               ? galleryItems[current].full_url
//               : "https://images.unsplash.com/photo-1523050853064-dbad350090ad"
//           }
//           style={styles.heroImg}
//         />

//         <div style={styles.overlay}></div>

//         <div style={styles.heroContent}>
//           <h1>{selectedCategory.toUpperCase()}</h1>
//           <p>Explore Moments & Memories</p>
//         </div>

//         <div style={styles.dots}>
//           {galleryItems.map((_, i) => (
//             <span
//               key={i}
//               onClick={() => setCurrent(i)}
//               style={{
//                 ...styles.dot,
//                 background:
//                   current === i ? "rgb(0,111,47)" : "#fff",
//               }}
//             />
//           ))}
//         </div>
//       </div>

//       {/* CATEGORY */}
//       <div style={styles.categoryBar}>
//         <div style={styles.scrollContainer}>
//           {categories.map((cat) => (
//             <div
//               key={cat.id}
//               onClick={() => {
//                 setSelectedCategory(cat.id);
//                 setCurrent(0);
//               }}
//               style={{
//                 ...styles.categoryTab,
//                 background:
//                   selectedCategory === cat.id
//                     ? "rgb(0,111,47)"
//                     : "#fff",
//                 color:
//                   selectedCategory === cat.id ? "#fff" : "#333",
//               }}
//             >
//               <span>{cat.icon}</span>
//               <span>{cat.label}</span>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* GALLERY */}
//       <section style={styles.section}>
//         {galleryItems.length > 0 ? (
//           <div className="galleryGrid">
//             {galleryItems.map((item, i) => (
//               <div
//                 className="card"
//                 key={i}
//                 onClick={() => setActiveIndex(i)}
//               >
//                 {item.type === "video" ? (
//                   <video src={item.full_url} className="media" />
//                 ) : (
//                   <img src={item.full_url} className="media" />
//                 )}

//                 <div className="overlayCard">
//                   <p>View</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <p style={{ textAlign: "center" }}>No Data Found</p>
//         )}

//         {/* LIGHTBOX */}
//         {activeIndex !== null && (
//           <div style={styles.lightbox}>
//             <span style={styles.close} onClick={() => setActiveIndex(null)}>✕</span>
//             <span style={styles.prev} onClick={() => setActiveIndex(activeIndex === 0 ? galleryItems.length - 1 : activeIndex - 1)}>‹</span>
//             <span style={styles.next} onClick={() => setActiveIndex(activeIndex === galleryItems.length - 1 ? 0 : activeIndex + 1)}>›</span>

//             {galleryItems[activeIndex].type === "video" ? (
//               <video src={galleryItems[activeIndex].full_url} controls autoPlay style={styles.lightMedia} />
//             ) : (
//               <img src={galleryItems[activeIndex].full_url} style={styles.lightMedia} />
//             )}
//           </div>
//         )}

//         <style>{styles.galleryCSS}</style>
//       </section>

//       <Footer />
//     </>
//   );
// };

// export default ShowGallery;

// const styles = {
//   hero: {
//     position: "relative",
//     height: "clamp(220px, 50vh, 550px)",
//     overflow: "hidden",
//     marginTop: "clamp(80px, 12vw, 120px)",
//   },

//   heroImg: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },

//   overlay: {
//     position: "absolute",
//     inset: 0,
//     background: "linear-gradient(rgba(0,111,47,0.5), rgba(0,0,0,0.7))",
//   },

//   heroContent: {
//     position: "absolute",
//     bottom: "clamp(20px, 5vw, 40px)",
//     left: "50%",
//     transform: "translateX(-50%)",
//     color: "#fff",
//     textAlign: "center",
//     width: "90%",
//   },

//   dots: {
//     position: "absolute",
//     bottom: "15px",
//     left: "50%",
//     transform: "translateX(-50%)",
//     display: "flex",
//     gap: "8px",
//   },

//   dot: {
//     width: "10px",
//     height: "10px",
//     borderRadius: "50%",
//     cursor: "pointer",
//   },

//   categoryBar: {
//     padding: "15px 0",
//     background: "#fff",
//     position: "sticky",
//     top: 0,
//     zIndex: 10,
//   },

//   scrollContainer: {
//     display: "flex",
//     gap: "10px",
//     overflowX: "auto",
//     padding: "0 16px",
//   },

//   categoryTab: {
//     padding: "10px 18px",
//     borderRadius: "50px",
//     border: "1px solid #ddd",
//     cursor: "pointer",
//     display: "flex",
//     gap: "8px",
//     whiteSpace: "nowrap",
//     flexShrink: 0,
//   },

//   section: {
//     padding: "40px 16px",
//     maxWidth: "1200px",
//     margin: "0 auto",
//   },

//   lightbox: {
//     position: "fixed",
//     inset: 0,
//     background: "rgba(0,0,0,0.95)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 9999,
//   },

//   lightMedia: {
//     maxWidth: "90%",
//     maxHeight: "85%",
//     borderRadius: "10px",
//   },

//   close: {
//     position: "absolute",
//     top: "20px",
//     right: "30px",
//     fontSize: "35px",
//     color: "#fff",
//     cursor: "pointer",
//   },

//   prev: {
//     position: "absolute",
//     left: "20px",
//     fontSize: "60px",
//     color: "#fff",
//     cursor: "pointer",
//   },

//   next: {
//     position: "absolute",
//     right: "20px",
//     fontSize: "60px",
//     color: "#fff",
//     cursor: "pointer",
//   },

//   galleryCSS: `
//     .galleryGrid {
//       display: grid;
//       grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
//       gap: 16px;
//     }

//     .card {
//       position: relative;
//       height: 220px;
//       border-radius: 12px;
//       overflow: hidden;
//       cursor: pointer;
//       transition: 0.3s ease;
//     }

//     .card:hover {
//       transform: translateY(-5px);
//     }

//     .media {
//       width: 100%;
//       height: 100%;
//       object-fit: cover;
//     }

//     .overlayCard {
//       position: absolute;
//       inset: 0;
//       background: rgba(0,0,0,0.4);
//       display:flex;
//       justify-content:center;
//       align-items:center;
//       opacity:0;
//       transition:0.3s;
//       color:#fff;
//       font-weight:600;
//     }

//     .card:hover .overlayCard {
//       opacity:1;
//     }
//   `,
// };